<script>
import { mapGetters } from 'vuex';
import Dashboard from '@/home/components/Dashboard.vue';

export default {
  components: {
    Dashboard,
  },

  computed: {
    ...mapGetters(['appName']),
    ...mapGetters('auth', ['userHasNoRoles']),
  },
}
</script>

<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-md-6 offset-md-3">
        <div class="mt-3">
          <b-card>
            <h4 class="text-center">Welcome to {{appName}}</h4>

            <p v-if="userHasNoRoles" class="text-justify text-danger">
              Your user does not have any Roles.
              Please speak to your manager to
              assign relevant Roles to you.
            </p>

            <p v-else class="text-justify">
              Click on the menu at the top to
              choose the screen you want to go to.
            </p>

          </b-card>
        </div>

        <dashboard class="mt-3" />

      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// src/home/views/HomeView.vue